export default __webpack_public_path__ + "static/media/deliver-cycle.d7a0d0e5.jpg";